/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// state
import { TStore } from '@store/index';
import { StateCreator } from 'zustand';

// datatable conversionFactors
import { tableSchemaBase as columns } from '../conversion-factor.columns';

// types
import { TColumnsSchema } from '@global-types/index';

/* -------------------------------------------------------------------------- */
/*                                  Interface                                 */
/* -------------------------------------------------------------------------- */
export interface IConversionFactorsDatatableSlice {
	conversionFactorsDatatableOptions: TColumnsSchema[];
	setConversionFactorsDatatableOptions: (
		_conversionFactorsDatatableOptions: TColumnsSchema[]
	) => void;
}

/* -------------------------------------------------------------------------- */
/*                                    Slice                                   */
/* -------------------------------------------------------------------------- */

export const partializeConversionFactorsDatatableSlice = (
	s: any
): any => ({
	conversionFactorsDatatableOptions:
		s.conversionFactorsDatatableOptions,
});

const initialState = {
	conversionFactorsDatatableOptions: columns.filter(
		(item) => item.defaultVisible
	),
};

export const createConversionFactorsDatatableSlice: StateCreator<
	TStore,
	[['zustand/persist', any]],
	[],
	IConversionFactorsDatatableSlice
> = (set) => ({
	...initialState,
	setConversionFactorsDatatableOptions: (
		_conversionFactorsDatatableOptions: TColumnsSchema[]
	) =>
		set({
			conversionFactorsDatatableOptions:
				_conversionFactorsDatatableOptions,
		}),
});
